import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { safeFetch } from '../utils/safeFetch';

const normalizeUserType = (value) => String(value || '').trim().toLowerCase();

const useAuthUserType = (initialUserType = '') => {
  const [userType, setUserType] = useState(() => (
    normalizeUserType(initialUserType || localStorage.getItem('user_type'))
  ));
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fallbackUserType = normalizeUserType(initialUserType || localStorage.getItem('user_type'));
    setUserType(fallbackUserType);
  }, [initialUserType]);

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem('token');

    if (!token) {
      setUserType('');
      setLoaded(true);
      return () => {
        cancelled = true;
      };
    }

    setLoaded(false);

    const syncUserType = async () => {
      try {
        const data = await safeFetch(`${API_URL}/api/check-auth`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (cancelled) return;

        const nextUserType = normalizeUserType(data?.user_type);
        setUserType(nextUserType);

        if (nextUserType) {
          localStorage.setItem('user_type', nextUserType);
        } else {
          localStorage.removeItem('user_type');
        }
      } catch {
        if (cancelled) return;
        setUserType(normalizeUserType(initialUserType || localStorage.getItem('user_type')));
      } finally {
        if (!cancelled) {
          setLoaded(true);
        }
      }
    };

    syncUserType();

    return () => {
      cancelled = true;
    };
  }, [initialUserType]);

  return { userType, loaded };
};

export default useAuthUserType;
